import React from 'react';

const Hero = ({ imageSrc, imageAlt, title, description }) => {
	return (
		<header className="category-hero">
			<img className="hero-image" src={ imageSrc } alt={ imageAlt } />
			<div className="hero-content">
				<div className="row">
					<div className="col">
						<h1 className="title">{ title }</h1>
						<p>{ description }</p>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Hero;


// WEBPACK FOOTER //
// ./src/pages/category/common/Hero.js